"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoClient = void 0;
const tslib_1 = require("tslib");
class PromoClient {
    constructor(HttpClient) {
        this.httpClient = HttpClient;
    }
    getPromos(brand) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = 'promotions';
            if (brand) {
                url = `promotions?brand=${brand.toLowerCase()}`;
            }
            const data = yield this.httpClient.get(url);
            return data;
        });
    }
}
exports.PromoClient = PromoClient;
//# sourceMappingURL=promoClient.js.map